module.exports = __webpack_public_path__ + "img/slogan01.7f5bc65d.png";